import { render, staticRenderFns } from "./EFaltasDoLimite.vue?vue&type=template&id=206d43ae&scoped=true"
import script from "./EFaltasDoLimite.vue?vue&type=script&lang=js"
export * from "./EFaltasDoLimite.vue?vue&type=script&lang=js"
import style0 from "./EFaltasDoLimite.vue?vue&type=style&index=0&id=206d43ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d43ae",
  null
  
)

export default component.exports